exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._10Jxoh4ILfCniaVirbfeHw{min-width:100%;min-height:40px}html[dir] ._10Jxoh4ILfCniaVirbfeHw{background-color:\"[theme:neutralLighter, default:#f4f4f4]\"}html[dir=ltr] ._10Jxoh4ILfCniaVirbfeHw,html[dir=rtl] ._10Jxoh4ILfCniaVirbfeHw{padding-left:0;padding-right:0}html[dir] ._10Jxoh4ILfCniaVirbfeHw .ms-CommandBarItem-link:hover{background-color:\"[theme:themeLight, default:#C7E0F4]\"}html[dir] ._2knNdUU_iO83L3LID69Cyo:hover{background:\"[theme:themeLight, default:#C7E0F4]\"!important}", ""]);

// exports
exports.locals = {
	"commandBar": "_10Jxoh4ILfCniaVirbfeHw",
	"settingsButton": "_2knNdUU_iO83L3LID69Cyo"
};